import { useQuery } from "@tanstack/react-query"
import { apiClientV2 } from "../../../services/api/apiClient"
import type { RegulationOut } from "./types/masterData"

const BASE = "/material-compliance/master-data/regulations"

// ─── List (lookup, unpaginated) ───────────────────────────────────────────────

// No long staleTime: each option's `inOrgSet` follows the org's set, which (without
// saved regulations) is inferred from verdicts that many writers change, some in
// backend jobs. Re-read on each open, like the dashboards that follow the same set.
export function useRegulations() {
  return useQuery({
    queryKey: ["mc", "regulations", "list"],
    queryFn: () => apiClientV2.get<RegulationOut[]>(BASE).then((r) => r.data),
  })
}
